import { Seo } from '../components/Seo';
import {Header} from '../components/Header';
import {Footer} from '../components/Footer';

const NoPage = () => {

  return (
    <>


      <Seo
        title="title"
        description="descr"
        type="webapp"
      />

      <Header selectedNavitem="home" />

        <p>no page</p>

      <Footer />

    </>
    )
  };
  
  export default NoPage;